enum EFeatureName {
  OPPORTUNITY_SEARCH_ANNIVERSARY = 'opportunity_search_anniversary',
  DOWNLOAD_MARKET_DATA = 'download_market_data',
  OPPORTUNITY_SEARCH_WITHDRAWN = 'opportunity_search_withdrawn',
  OPPORTUNITY_SEARCH_LIKELY_SOLD = 'opportunity_search_likely_sold',
  PITCH_PANEL = 'pitch_panel',
  ROI_DASHBOARD = 'roi_dashboard',
  UPLOAD_DATA = 'upload_data',
  AUTOMATED_EMAIL = 'automated_email',
}

export { EFeatureName };
